import { createFileRoute, redirect } from "@tanstack/react-router";
import { meQueryOptions } from "@/lib/session";

/**
 * The onboarding gate.
 *
 * A second pathless layout INSIDE `_auth`, rather than a check in `_auth`
 * itself, because `/onboarding` has to stay reachable while the profile is
 * still incomplete. Nesting expresses that: onboarding sits directly under
 * `_auth`, everything that needs a finished profile sits under this.
 *
 * The alternative — one guard comparing the pathname against "/onboarding" —
 * is the version that redirects the onboarding page to itself forever the day
 * someone renames it.
 *
 * What belongs under here is what a finished profile is FOR: the dashboard and
 * applying. `/coord/*` and `/admin` deliberately sit outside it, next to
 * `/onboarding`. A coordinator is not necessarily an applicant, and making one
 * upload a resume before they can open their own vertical's applicant list is
 * a gate on the wrong person — it reads as a bug, and it is one.
 */
export const Route = createFileRoute("/_auth/_onboarded")({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQueryOptions);
    if (me && !me.profileComplete) {
      throw redirect({ to: "/onboarding" });
    }
  },
});
